/* eslint-disable no-unused-vars */
import React, {useEffect, useState, useContext} from 'react';
import {ListItem} from './list-item.component';
import {ListInterface} from './list.interface';
import {ListItemInterface} from './list.interface';
import {ListAddressItem} from './list-address.component';
import {AlertModel, StopModel, RouteModel, Itinerary, RealTime} from '../../core/models';
import {DataContext} from '../../services/data-v2/data.context';

import './list.scss';

const hasAlertForItem = (item: ListItemInterface<any>, alerts: AlertModel[]): boolean => {
    const itemRouteId = item.data.routeId;
    const itemRoutesIds = item.data.routesIds;
    if (itemRouteId) {
        return alerts.some((alert) => alert.alertRoute.includes(itemRouteId));
    } else if (Array.isArray(itemRoutesIds) && itemRoutesIds.length > 0) {
        return alerts.some((alert) =>
            itemRoutesIds.some((routeId) => alert.alertRoute.includes(routeId)),
        );
    }
    return false;
};


export const List = (props: ListInterface<any>) => {
    const alerts = props.currentStopAlerts || [];
    const {realTimes} = useContext(DataContext);
    const [sortedItems, setSortedItems] = useState<ListItemInterface<any>[]>([]);

    useEffect(() => {
        const fetchRealTimes = () => {
            if (Array.isArray(props.items)) {
                const itemsWithRealTimes = props.items.map((item) => {
                    const subtitle = item.subtitle as any;

                    if (subtitle && subtitle.props && subtitle.props.stop && subtitle.props.route) {
                        const stop = subtitle.props.stop as StopModel;
                        const route = subtitle.props.route as RouteModel;
                        const rt: RealTime[] = realTimes[stop.id]?.realTimes[route.id] || [];

                        return {
                            ...item,
                            realTimes: rt,
                        };
                    } else {
                        return {
                            ...item,
                            realTimes: [],
                        };
                    }
                });

                const sorted = itemsWithRealTimes.sort((a, b) => {
                    const aFirstRt = a.realTimes[0]?.arrivalTime ?? Infinity;
                    const bFirstRt = b.realTimes[0]?.arrivalTime ?? Infinity;
                    return aFirstRt - bFirstRt;
                });

                setSortedItems(sorted);
            } else {
                setSortedItems([]);
            }
        };

        fetchRealTimes();
    }, [props.items, realTimes]);

    return (
        <div className="list-container">
            {props.title && <div className="title">{props.title}</div>}
            <div className="list">
                {sortedItems.map((item, index) =>
                    props.isAddressList ? (
                        <ListAddressItem key={index} {...item} />
                    ) : (
                        <ListItem
                            key={index}
                            {...item}
                            hasAlert={hasAlertForItem(item, alerts)}
                        />
                    ),
                )}
            </div>
        </div>
    );
};
